const testimonials = [
  {
    name: "Captain Mike D.",
    role: "Marco Island Marina — Sportfishing Charter",
    highlight: "Bimini tournament in 2 days — expired passport crisis",
    story:
      "I run a sportfishing charter out of Marco Island Marina. We had a Bimini tournament entry confirmed for months. Two days before departure, my first mate discovered his passport had expired six months ago. Tournament fees were $4,500 non-refundable, and the weather window was perfect — we could not delay. I called Fast Passport Center in a panic. They got his renewal processed and shipped overnight to my dock in 48 hours. We made the tournament, placed second, and now every captain in my network has their number saved. I have never seen anything move that fast.",
    rating: 5,
    tag: "Emergency",
  },
  {
    name: "Margaret &amp; Richard S.",
    role: "Seasonal Residents from Greenwich, CT",
    highlight: "Amalfi Coast villa rental — six-month validity rule",
    story:
      "We rented a villa on the Amalfi Coast for three weeks in June. The property required full payment 60 days in advance — non-refundable. Three weeks before departure, Richard checked his passport and it expired in July — only one month after our return. The Italian entry requirement is six months beyond your departure date, so he was not getting in. We called Fast Passport Center from our condo on Marco Island. They walked us through the expedited renewal, and Richard had his new passport in five days. We made the trip, and Positano was every bit as magical as we imagined. They literally saved a $28,000 vacation.",
    rating: 5,
    tag: "Luxury Travel",
  },
  {
    name: "The Brennan Family",
    role: "Year-Round Marco Island Residents",
    highlight: "Daughter's first passport for Cancun spring break",
    story:
      "We booked an all-inclusive in Cancun for our daughter's first spring break trip with her best friend. Neither of us had ever applied for a child passport, and we assumed it was like getting a driver's license — walk in, walk out. We were wrong. You need both parents present or notarized consent, the child has to appear, and the process takes weeks unless you expedite. We started six weeks before departure, which seemed like plenty of time. But we made a mistake on the DS-11 form and had to resubmit. Fast Passport Center caught the error in their pre-review, corrected it, and got her passport processed in eight days. She made the trip, and now we know: never underestimate the child passport process.",
    rating: 5,
    tag: "Child Passport",
  },
];

export default function MarcoIslandTestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Marco Island Client Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Marco Island Travelers Say About Us
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>

              <div className="inline-block bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
                {t.tag}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-4">
                <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                <div className="text-gray-500 text-xs">{t.role}</div>
              </div>

              <div className="mt-3 bg-[#1A365D]/5 rounded-md px-3 py-2">
                <p className="text-[#1A365D] text-xs font-semibold">{t.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}